import { useTranslation } from 'react-i18next';

const IntroSection = () => {
  const { t } = useTranslation('choHem');

  const problems = [
    { icon: 'ri-question-line', text: t('intro.problem1') },
    { icon: 'ri-translate-2', text: t('intro.problem2') },
    { icon: 'ri-file-list-3-line', text: t('intro.problem3') },
    { icon: 'ri-map-pin-2-line', text: t('intro.problem4') },
  ];

  return (
    <section className="py-14 md:py-24 bg-gradient-to-b from-gray-950 to-black relative overflow-hidden">
      <div className="absolute top-0 right-0 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-amber-600/5 rounded-full blur-3xl pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center">
          {/* Image */}
          <div className="relative rounded-2xl overflow-hidden border border-amber-500/20 shadow-2xl shadow-amber-500/10">
            <img
              src="https://public.readdy.ai/ai/img_res/3f5419a352d963e6a448ec4edcdb5aa3.jpg"
              alt="Chủ kiosk Chợ Hẻm Asian Alley"
              className="w-full h-64 sm:h-80 md:h-[480px] object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
            <div className="absolute bottom-4 left-4 right-4">
              <div className="bg-black/70 backdrop-blur-sm rounded-xl p-3 border border-amber-500/30">
                <p className="text-amber-400 font-bold text-xs sm:text-sm">{t('intro.imageCaption')}</p>
                <p className="text-gray-300 text-xs mt-0.5">{t('intro.imageSubCaption')}</p>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="text-white">
            <span className="inline-block px-3 py-1 bg-amber-500/15 border border-amber-400/30 rounded-full text-xs text-amber-300 font-semibold uppercase tracking-wider mb-4">
              {t('intro.badge')}
            </span>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 font-serif leading-tight">
              {t('intro.title.line1')} <br />
              <span className="bg-gradient-to-r from-amber-300 to-amber-500 bg-clip-text text-transparent">
                {t('intro.title.line2')}
              </span>
            </h2>

            <div className="space-y-3 mb-8">
              {problems.map((p, i) => (
                <div key={i} className="flex items-center gap-3 p-3 bg-white/5 border border-white/10 rounded-xl">
                  <div className="w-9 h-9 flex items-center justify-center bg-amber-500/20 rounded-lg flex-shrink-0">
                    <i className={`${p.icon} text-amber-400 text-base`}></i>
                  </div>
                  <p className="text-gray-300 text-sm">{p.text}</p>
                </div>
              ))}
            </div>

            <div className="p-5 bg-amber-500/10 border border-amber-400/25 rounded-2xl">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-amber-500 rounded-xl flex-shrink-0">
                  <i className="ri-lightbulb-flash-line text-black text-lg"></i>
                </div>
                <div>
                  <p className="text-amber-400 font-bold text-sm mb-1">{t('intro.solution.title')}</p>
                  <p className="text-gray-300 text-sm leading-relaxed">
                    {t('intro.solution.desc')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;